import {toAsterisk, toExpirationDate} from '@logistics-frontend/core/formatters'

import {CardSystem, isKnownCardSystem, PaymentCard} from '../../../model/payment'
import {CardDetailsResponse} from '../../../repo/dcaa'

function toSystem(system: string): CardSystem {
  const lowerSystem = system.toLowerCase()
  if (isKnownCardSystem(lowerSystem)) {
    return lowerSystem
  }

  return 'unknown'
}

export function toPaymentCard(response: CardDetailsResponse): PaymentCard {
  return {
    __type: 'card',
    id: response.card_details.card_id,
    system: toSystem(response.card_details.system),
    number: toAsterisk(response.card_details.number),
    expirationDate: toExpirationDate(response.card_details.expiration_year, response.card_details.expiration_month),
  }
}
